import { NumericAspect } from "@/models/HomePageSearchResponse";

const PRICE_OPTIONS: NumericAspect[] = [
  {
    value: 1000,
    label: "$1,000",
  },
  {
    value: 2000,
    label: "$2,000"
  },
  {
    value: 3000,
    label: "$3,000"
  },
  {
    value: 4000,
    label: "$4,000"
  },
  {
    value: 5000,
    label: "$5,000"
  },
  {
    value: 7500,
    label: "$7,500"
  },
  {
    value: 10000,
    label: "$10,000"
  },
  {
    value: 15000,
    label: "$15,000"
  },
  {
    value: 20000,
    label: "$20,000"
  },
  {
    value: 25000,
    label: "$25,000"
  },
  {
    value: 30000,
    label: "$30,000"
  },
  {
    value: 35000,
    label: "$35,000"
  },
  {
    value: 40000,
    label: "$40,000"
  },
  {
    value: 45000,
    label: "$45,000"
  },
  {
    value: 50000,
    label: "$50,000"
  },
  {
    value: 60000,
    label: "$60,000"
  },
  {
    value: 70000,
    label: "$70,000"
  },
  {
    value: 80000,
    label: "$80,000"
  },
  {
    value: 90000,
    label: "$90,000"
  },
  {
    value: 100000,
    label: "$100,000"
  },
];

export default PRICE_OPTIONS;
